import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=543d9d85&scoped=true&"
import script from "./UploadButton.vue?vue&type=script&lang=js&"
export * from "./UploadButton.vue?vue&type=script&lang=js&"
import style0 from "./UploadButton.vue?vue&type=style&index=0&id=543d9d85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543d9d85",
  null
  
)

export default component.exports